<template>
  <div class="container-fluid p-2" style="background: #2B0000; padding-bottom: 80rem !important;">
    
    <div v-if="contactInfo.admin">
      <h4 class="text-center text-md my-4" style="color: #ccc; font-weight: 400">အောက်ပါဖုန်းနံပါတ်သည် <br> ရွှေအိုး ကုမ္ပဏီ၏ ဝန်ဆောင်မှုဖုန်းနံပါတ်ဖြစ်သည်။ <br>နေ့စဉ်(၂၄) နာရီ ၊ ပိတ်ရက်မရှိ ဝန်ဆောင်ပေးနေပါသည်။</h4> 

      <div class="card mx-2" style="box-shadow: none !important; border-radius: 0.5rem !important; background: #590007 !important;">
        <div class="card-body px-0 py-0">
          <div class="account-container-wrapper pl-0 my-2 py-2">
            <div class="col-12 my-auto">
              <div class="mb-4">
                <span class="text-sm text-white">
                  ဝန်ဆောင်မှု ဖုန်းနံပါတ်
                </span>
              </div>
              
              <div class="d-flex justify-content-between my-3">
                <span class="text-sm text-white my-auto">
                  {{ contactInfo.admin.viber1 }}
                </span>
                <a :href="viberLink(contactInfo.admin.viber1)">
                  <button
                      type="button"
                      class="btn btn-dark"
                      style="background: #fff; color: black; border-radius: .5rem; width: 6rem; box-shadow: none;"
                  >
                    <img src="https://storage.googleapis.com/spacetech2/shweohhh/shweohh_viber.png" style="width: 1.1rem;" class="mr-2" />  Viber
                  </button>
                </a>
              </div>
              <div class="d-flex justify-content-between my-3">
                <span class="text-sm text-white my-auto">{{ contactInfo.admin.viber2 }}</span>
                <a :href="viberLink(contactInfo.admin.viber2)">
                  <button
                      type="button"
                      class="btn btn-dark"
                      style="background: #fff; color: black; border-radius: .5rem; width: 6rem; box-shadow: none;"
                  >
                    <img src="https://storage.googleapis.com/spacetech2/shweohhh/shweohh_viber.png" style="width: 1.1rem;" class="mr-2" />  Viber
                  </button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card mx-2" style="box-shadow: none !important; border-radius: 0.5rem !important; background: #590007 !important;">
        <div class="card-body px-0 py-0">
          <div class="account-container-wrapper pl-0 my-2 py-2">
            <div class="col-12 my-auto">
              <div class="mb-4">
                <span class="text-sm text-white">
                  ကိုယ်စားလှယ်ဝင်ဖို့ စုံစမ်းရန်
                </span>
              </div>
              
              <div class="d-flex justify-content-between my-3">
                <span class="text-sm text-white my-auto">
                  {{ contactInfo.admin.viber3 }}
                </span>
                <a :href="viberLink(contactInfo.admin.viber3)">
                  <button
                      type="button"
                      class="btn btn-dark"
                      style="background: #fff; color: black; border-radius: .5rem; width: 6rem; box-shadow: none;"
                  >
                    <img src="https://storage.googleapis.com/spacetech2/shweohhh/shweohh_viber.png" style="width: 1.1rem;" class="mr-2" />  Viber
                  </button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div v-if="contactInfo.agent">
      <h4 class="text-center text-md my-4" style="color: #ccc; font-weight: 400">အောက်ပါဖုန်းနံပါတ်သည် <br> မိမိ မိတ်ဆက်ကုဒ် ဖြည့်ထားသော ကိုယ်စားလှယ်၏ဖုန်းနံပါတ်ဖြစ်သည်</h4>
      <div class="card mx-2" style="box-shadow: none !important; border-radius: 0.5rem !important; background: #590007 !important;">
        <div class="card-body px-0 py-0">
          <div class="account-container-wrapper d-flex pl-0 my-2 py-2">
            <div class="col-12">
              <div class="d-flex justify-content-between">
                <span class="text-sm text-white">
                  ကိုယ်စားလှယ်အမည်
                </span>
                <span style="color: #EFDB01">
                  {{ contactInfo.agent_name }}
                </span> 
              </div>
              <br>
              <div class="d-flex justify-content-between">
                <span class="text-sm text-white">ကိုယ်စားလှယ်၏ မိတ်ဆက်ကုဒ်</span>
                <span style="color: #EFDB01">
                  {{ contactInfo.agent_code }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card mx-2" style="box-shadow: none !important; border-radius: 0.5rem !important; background: #590007 !important;" v-if="contactInfo.agent.viber1 || contactInfo.agent.viber2">
        <div class="card-body px-0 py-0">
          <div class="account-container-wrapper pl-0 my-2 py-2">
            <div class="col-12 my-auto">
              <div class="mb-4">
                <span class="text-sm text-white">
                  ကိုယ်စားလှယ်ကိုဆက်သွယ်ရန်
                </span>
              </div>
              
              <div class="d-flex justify-content-between my-3" v-if="contactInfo.agent.viber1">
                <span class="text-sm text-white my-auto"> 
                  {{ contactInfo.agent.viber1 }}
                </span>
                <a :href="viberLink(contactInfo.agent.viber1)">
                  <button
                      type="button"
                      class="btn btn-dark"
                      style="background: #fff; color: black; border-radius: .5rem; width: 6rem; box-shadow: none;"
                  >
                    <img src="https://storage.googleapis.com/spacetech2/shweohhh/shweohh_viber.png" style="width: 1.1rem;" class="mr-2" />  Viber
                  </button>
                </a>
                
              </div>
              <div class="d-flex justify-content-between my-3" v-if="contactInfo.agent.viber1">
                <span class="text-sm text-white my-auto"> {{ contactInfo.agent.viber2 }}</span>
                <a :href="viberLink(contactInfo.agent.viber2)">
                  <button
                      type="button"
                      class="btn btn-dark"
                      style="background: #fff; color: black; border-radius: .5rem; width: 6rem; box-shadow: none;"
                  >
                    <img src="https://storage.googleapis.com/spacetech2/shweohhh/shweohh_viber.png" style="width: 1.1rem;" class="mr-2" />  Viber
                  </button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card mx-2" style="box-shadow: none !important; border-radius: 0.5rem !important; background: #590007 !important;" v-if="contactInfo.agent.viber3">
        <div class="card-body px-0 py-0">
          <div class="account-container-wrapper pl-0 my-2 py-2">
            <div class="col-12 my-auto">
              <div class="mb-4">
                <span class="text-sm text-white">
                  ကိုယ်စားလှယ်ဝင်ဖို့ စုံစမ်းရန်
                </span>
              </div>
              
              <div class="d-flex justify-content-between my-3" v-if="contactInfo.agent.viber1">
                <span class="text-sm text-white my-auto"> 
                  {{ contactInfo.agent.viber3 }}
                </span>
                <a :href="viberLink(contactInfo.agent.viber3)">
                  <button
                      type="button"
                      class="btn btn-dark"
                      style="background: #fff; color: black; border-radius: .5rem; width: 6rem; box-shadow: none;"
                  >
                    <img src="https://storage.googleapis.com/spacetech2/shweohhh/shweohh_viber.png" style="width: 1.1rem;" class="mr-2" />  Viber
                  </button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  data() {
    return {
      contactInfo: [],
    };
  },
  methods: {
    ...mapActions(['fetchUser']),
    viberLink(phone) {
      return `viber://contact?number=%2B${phone.replace('+', '')}`;
    },
    async fetchWebsiteData() {
      try {
        const res = await axios.get('/user-contact',
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`,
              },
          }
        );
        this.contactInfo = res.data;
      } catch (error) {
        console.log(error);
      }
    },
  },
  async mounted() {
    const authUser = await this.fetchUser();
    if (!authUser) {
      this.$router.push('/auth/login');
    }
    this.fetchWebsiteData();
  },
};
</script>
